import { DockerSetupFormData } from './types';
import { HostSection } from './HostSection';
import { OtherSection } from './OtherSection';
import { TimeWindowSection } from './TimeWindowSection';

interface Props {
  formData: DockerSetupFormData;
  onChange: <K extends keyof DockerSetupFormData>(
    key: K,
    value: DockerSetupFormData[K]
  ) => void;
  timeZone?: string;
  onChangeTimeZone?: (timeZone: string) => void;
}

/**
 * Docker Setup Policy form fields.
 * Pure field renderer without FormActions - used by both create and edit modes.
 */
export function DockerSetupFormFields({
  formData,
  onChange,
  timeZone = 'UTC',
  onChangeTimeZone = () => {},
}: Props) {
  return (
    <>
      <HostSection formData={formData} onChange={onChange} />
      <OtherSection formData={formData} onChange={onChange} />
      <TimeWindowSection
        formData={formData}
        onChange={onChange}
        timeZone={timeZone}
        onChangeTimeZone={onChangeTimeZone}
      />
    </>
  );
}
